import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBFeedModerationStatus = Database["public"]["Enums"]["feed_moderation_status"];

export const FeedModerationStatus = {
	PENDING: "pending",
	APPROVED: "approved",
	REJECTED: "rejected",
} as const satisfies Record<string, DBFeedModerationStatus>;

export type FeedModerationStatus = (typeof FeedModerationStatus)[keyof typeof FeedModerationStatus];

type _EnsureAllDBValues = Exclude<DBFeedModerationStatus, FeedModerationStatus> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const FEED_MODERATION_STATUSES = Object.values(FeedModerationStatus) as readonly FeedModerationStatus[];

export const feedModerationStatusSchema = z.enum(FeedModerationStatus);

export const FEED_MODERATION_STATUS_LABELS: Record<FeedModerationStatus, string> = {
	pending: "Pending approval",
	approved: "Approved",
	rejected: "Rejected",
};
